import { render, staticRenderFns } from "./updatingList.vue?vue&type=template&id=20198fcc&scoped=true"
import script from "./updatingList.vue?vue&type=script&lang=js"
export * from "./updatingList.vue?vue&type=script&lang=js"
import style0 from "./updatingList.vue?vue&type=style&index=0&id=20198fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20198fcc",
  null
  
)

export default component.exports